import React, { useMemo } from 'react'
import classNames from 'classnames'
import { useAppData, useRouteProps } from 'umi'
import toolsRoutes from '@/routes/toolsRoutes'

import Menu from '../Menu'

import styles from './index.less'

const [{ routes }] = toolsRoutes

const menus = routes.map((router) => ({
  path: router.path,
  logo: router?.meta?.menuIcon,
  name: router?.name
}));

const CreatePlatformToolsNav = () => {
  // const router = useRouteProps()

  return (
    <div className={styles.navWrapper}>
      <div className={styles.nav}>
        AI工具箱
        <span className={classNames([`icon-TriDown`, styles.icon])} />
      </div>
      <div className={styles.placeWrapper}>
        <div className={styles.navPopup}>
          <Menu menus={menus} />
        </div>
      </div>
    </div>
  )
}

export default CreatePlatformToolsNav
